module.exports = __webpack_public_path__ + "static/media/2025-Summer-of-Cricket-Logged-Out-308x280.d67387a8.png";